var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-state"},[_c('span',{staticClass:"badge",class:`badge__${_vm.badgeStyle}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }